var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"slider_cell"},[_c('div',{staticClass:"slider_bg"},[_c('div',{staticClass:"slider_a",style:({
        width: _vm.rates[0] >= 999 ? '94%' : _vm.lineWidth,
        left: _vm.rates[0] >= 999 ? '2%' : _vm.left,
        backgroundColor: _vm.rates[0] >= 999 ? '#EE3F3F' : '#6883FB',
      })},[_c('p',{staticClass:"slider_l",style:({ left: _vm.rates[0] >= 999 ? '-20px' : '-40px;' })},[_vm._v(" "+_vm._s(_vm.rates[0] / 10)+"% ")]),_c('p',{staticClass:"slider_r",style:({ right: _vm.rates[0] >= 999 ? '-10px' : '-45px;' })},[_vm._v(" "+_vm._s(_vm.rates[1] / 10)+"% ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }